import { observable, toJS } from "mobx";
import OrcamentoExportService from "../../../../../services/OrcamentoExportService";
import { formatarDataCustomHTML, formatarReal, situacaoOrcamentoFormatter, formatarCnpj } from "../../../../../utils/formatar";
import { buscaFiltrarVazio, buscaSemResultado } from "../../../../../utils/mensagens";
import { sortCaret } from '../../../../comum/components/Icones';

export default class OrcamentoExportStore {

    @observable predefinicao;
    @observable documento;

    @observable loading;
    @observable loadingTipos;
    @observable listaExportacao;
    @observable listaNaoSelecionados;
    @observable listaSelecionados;
    @observable listaTipos;
    @observable tableMessage;
    @observable dadosExportacao;

    @observable modalGerarBoleto;
    @observable enviandoCliente;
    @observable loadingBoleto;
    @observable addCliente;

    @observable alerta;

    @observable filtrado;

    constructor() {

        this.predefinicao = ""
        this.documento = ""

        this.modalRefCliente = false
        this.enviandoCliente = false
        this.loadingTipos = false
        this.loadingBoleto = false

        this.addCliente = ""

        this.alerta = ""

        this.listaExportacao = []
        this.listaNaoSelecionados = []
        this.listaSelecionados = []
        this.listaTipos = []
        this.dadosExportacao = null
        this.tableMessage = buscaFiltrarVazio.replace('Filtrar', 'Processar')
        this.colunas = this.todasColunas

        this.filtrado = false

        this.download = document.createElement('a')
        document.body.appendChild(this.download)
        this.download.style = "display: none"
        this.download.target = "_blank"

        this.service = new OrcamentoExportService()

        this.listarTipos()
    }

    setPredefinicoes = (event) => {
        if (event) {
            this.predefinicao = event.target.value;
        } else {
            this.predefinicao = this.listaTipos[0].value
        }
    }

    setDocumento = (event) => {
        if (!event) this.documento = ""
        this.documento = event.target.value
    }

    setCliente = (event) => {
        if (!event) this.addCliente = ""
        this.addCliente = event.target.value
    }

    abrirModalBoleto = () => {
        this.modalGerarBoleto = true;
    }

    fecharModalBoleto = () => {
        this.addCliente = ""
        this.modalGerarBoleto = false;
    }

    fecharModalAviso = () => {
        this.alerta = ""
    }

    listarTipos = () => {
        this.loadingTipos = true;
        this.service.ListarTipos().then((response) => {
            if (response && response.data) {
                this.listaTipos = response.data.map((tipo) => ({
                    id: tipo.Codigo, value: tipo.Codigo, label: tipo.Descr, checked: false
                }));
                if (this.listaTipos.length > 0) {
                    this.listaTipos[0].checked = true;
                    this.predefinicao = this.listaTipos[0].value;
                }
            }
        }
        ).catch(err => console.error(err)
        ).finally(() => this.loadingTipos = false);
    }

    calculaTotal = () => {
        const totais = this.listaSelecionados.map(v => v.ValorPagar);
        const total = totais.length > 0 ? totais.reduce((t, value) => t + value) : 0;
        return total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });
    }

    listaDadosBoleto = () => {
        let prestadorBoleto = toJS(this.dadosExportacao);
        const selecionados = this.listaSelecionados.map(selecionado => selecionado.OsId);
        prestadorBoleto.forEach(prestador => {
            prestador.Servicos.forEach(servico => {
                selecionados.includes(servico.OsId) ? servico.Pagar = true : servico.Pagar = false
            });
            prestador.Servicos = prestador.Servicos.filter(s => s.Pagar); //S de serviço
        });
        prestadorBoleto = prestadorBoleto.filter(p => p.Servicos.length > 0); //P de prestador
        //prestadorBoleto.forEach(prestador => prestador.Servicos.forEach(servico => delete servico.selecionado));
        return prestadorBoleto;
    }

    gerarBoleto = () => {
        this.loadingBoleto = true;
        //Eu preciso fazer isso para excluir o atributo selecionado, mas sem destruir a lista original de selecionados
        let select = this.listaSelecionados;
        //select.forEach(s => delete s.selecionado)

        const prestadorBoleto = this.listaDadosBoleto();

        this.service.GerarBoleto(this.predefinicao, this.documento, this.addCliente, prestadorBoleto).then(response => {
            if (response.status !== 200) {
                this.alerta = response.data
            } else if (response && response.data) {
                const data = `<html><head><meta charset="UTF-8" /></head><body>${response.data}</body></html>`
                const file = new File([data], "boleto.html", { type: "text/html;charset=UTF-8" });
                const url = window.URL.createObjectURL(file)
                this.download.href = url
                this.download.click()
                window.URL.revokeObjectURL(url)
            }
        }).catch(err => console.error(err)
        ).finally(() => {
            this.loadingBoleto = false;
            this.fecharModalBoleto()
            this.pesquisar();
        });
    }

    pesquisar = () => {
        this.filtrado = true
        this.loading = true
        this.service.Pesquisar(this.predefinicao, this.documento).then(response => {
            if (response && response.data) {
                if (response.data.Sucesso) {
                    this.dadosExportacao = response.data.FatPrestadorDdeList;
                    this.listaExportacao = response.data.FatPrestadorDdeList.reduce((todos, servico) => todos.concat(servico.Servicos), []);

                    this.listaNaoSelecionados = this.listaExportacao.filter(exp => !exp.HabilitarPagamento).map(exp => exp.Id)

                    this.listaSelecionados = this.listaExportacao.filter(s => s.Pagar);

                    if (response.data.QuantTotalOS === 0) {
                        this.tableMessage = buscaSemResultado
                    } else {
                        this.tableMessage = buscaFiltrarVazio.replace('Filtrar', 'Processar')
                    }
                }
                else {
                    if (response.data.Mensagem)
                        this.alerta = response.data.Mensagem;
                }
            }
        }).catch(err => console.error(err)
        ).finally(() => this.loading = false)
    }

    incluirCliente = () => {
        this.loadingBoleto = true
        this.service.IncluirCliente(this.addCliente).then(response => {
            this.alerta = response.Mensagem
        }).catch(err => console.error(err)
        ).finally(() => {
            this.enviandoCliente = false
            this.fecharModalRefCliente()
            this.loadingBoleto = false
        })
    }

    selecionar = (data) => {
        data.Pagar = !data.Pagar
        this.listaSelecionados = this.listaExportacao.filter(i => i.Pagar === true);

    }

    selecionarTodos = (checked) => {
        this.listaExportacao.forEach(item => {
            if (item.HabilitarPagamento) {
                item.Pagar = checked
            }
        })

        this.listaSelecionados = this.listaExportacao.filter(i => i.Pagar === true)
    }

    permiteGerarBoleto = () => {
        return this.listaSelecionados.length > 0 && !this.listaTemMaisDeUmCliente();
    }

    listaTemMaisDeUmCliente = () => {
        const registros = this.listaSelecionados || [];
        for (let index = 0, cliente = 0; index < registros.length; index++) {
            const element = registros[index];
            const cobrarDeCgc = element.CobrarDeCgc;
            if (cliente === 0) cliente = cobrarDeCgc;
            else if (cliente !== cobrarDeCgc) return true
        }
        return false;
    }

    todasColunas = [
        {
            text: "OS",
            dataField: "OsId",
            sort: true,
            headerAlign: "left",
            sortCaret: sortCaret
        },
        {
            text: "Serviço",
            dataField: "DscTipoServico",
            sort: true,
            headerAlign: "left",
            sortCaret: sortCaret
        },
        {
            text: "Cliente",
            dataField: "Cliente",
            sort: true,
            headerAlign: "left",
            sortCaret: sortCaret,
            formatter: (cell, row, rowIndex) => row['Cliente'] + ' ' + formatarCnpj(row['ClienteCgc'])
        },
        {
            text: "Despachante",
            dataField: "Despachante",
            sort: true,
            headerAlign: "left",
            sortCaret: sortCaret
        },
        {
            text: "CTNR / DDE",
            dataField: "CodCntr",
            sort: true,
            headerAlign: "left",
            sortCaret: sortCaret
        },
        {
            text: "Saída",
            dataField: "DtSaida",
            sort: true,
            formatter: formatarDataCustomHTML,
            headerAlign: "left",
            sortCaret: sortCaret
        },
        {
            text: "Unitário",
            dataField: "ValorUnitario",
            sort: true,
            formatter: formatarReal,
            headerAlign: "left",
            sortCaret: sortCaret
        },
        {
            text: "Total",
            dataField: "ValorTotal",
            sort: true,
            formatter: formatarReal,
            headerAlign: "left",
            sortCaret: sortCaret
        },
        {
            text: "Faturado",
            dataField: "ValorPago",
            sort: true,
            formatter: formatarReal,
            headerAlign: "left",
            sortCaret: sortCaret
        },
        {
            text: "A faturar",
            dataField: "ValorPagar",
            sort: true,
            formatter: formatarReal,
            headerAlign: "left",
            sortCaret: sortCaret
        },
        {
            text: "Situação",
            dataField: "Legenda",
            sort: true,
            headerAlign: "center",
            formatter: situacaoOrcamentoFormatter,
            sortCaret: sortCaret
        }
    ]

    // outrosDados = [
    //     { titulo : "Despachante", field: ["Despachante"], id:"F1", hidden: false, dataField: 'Despachante', text: 'Despachante'},
    //     { titulo : "Cliente", field: ["Cliente"], id:"F2", hidden: false, dataField: 'Cliente', text: 'Cliente'},
    // ];
}


// WEBPACK FOOTER //
// ./src/modules/faturamento/orcamento/exportacao/stores/OrcamentoExportStore.js